import { useCallback } from "react";

import {
  useRequestWithFeedback,
  type OverrideRunProps,
} from "../../../composites";
import { useLibrary } from "../../../providers";

import { API } from "./api";

import type { PreferredLanguagePayload } from "./types";

export const useSetPreferredLanguage = () => {
  const l10n = useLibrary("translations");
  const { send, loading } = useRequestWithFeedback<PreferredLanguagePayload>();

  const setPreferredLanguage = useCallback(
    (
      payload: PreferredLanguagePayload,
      overrideRunProps?: OverrideRunProps<PreferredLanguagePayload>,
    ) => {
      send({
        action: API.setPreferredLanguage(payload),
        messaging: {
          toast: {
            error: l10n.getString(
              "language-preference-save-error",
              null,
              "There was an error updating your language preference. Please try again.",
            ),
          },
        },
        ...overrideRunProps,
      });
    },
    [l10n, send],
  );

  return { setPreferredLanguage, loading };
};
